import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=6169c9f7&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=6169c9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6169c9f7",
  null
  
)

export default component.exports